
// 1: pc传统直播间, 2:手机直播间, 3:vr, 4:音频连麦/语音房, 5:官方直播间,
export const LiveType = {
    pc:1,
    mobile:2,
    vr:3,
    voice:4,
    official:5
}


export const sex = ['女','男']

export const reg = {
    mobile: /[0-9]{5,}/,
    bankId: /[0-9]{16,}/,
    nature: /^[1-9]\d*$/, // 正自然数
    qq: /^[1-9]\d{3,}$/,
    chinaSfzNo: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
}


export const lightShowStage = {
  // 节目开始
  "start":0,
  // 麦位开始表演
  "show":1,
  // 麦位上的表演结束
  "ending":2,
  // 节目完成
  "finish":3
}


export const ladderLevel = [
  '不屈青铜III',
  '不屈青铜II',
  '不屈青铜Ⅰ',
  '英勇白银III',
  '英勇白银II',
  '英勇白银Ⅰ',
  '闪耀黄金III',
  '闪耀黄金II',
  '闪耀黄金Ⅰ',
  '永恒铂金III',
  '永恒铂金II',
  '永恒铂金Ⅰ',
]
